import { render } from "./StepTwo.vue?vue&type=template&id=023d809d&scoped=true&ts=true"
import script from "./StepTwo.vue?vue&type=script&lang=ts"
export * from "./StepTwo.vue?vue&type=script&lang=ts"

import "./StepTwo.vue?vue&type=style&index=0&id=023d809d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-023d809d"]])

export default __exports__